module.exports = {};



//////////////////
// WEBPACK FOOTER
// /app/node_modules/babel-polyfill/node_modules/core-js/modules/_iterators.js
// module id = 127
// module chunks = 0